// Place this component in App.js to enable bot on whole app
import { useEffect } from 'react';

function ProGPTBotLoader() {
  useEffect(() => {
    const botId = 'progpt_container';
    const scriptId = 'progpt_script';

    // Only add the bot container if it doesn't already exist
    let botContainer = document.getElementById(botId);
    if (!botContainer) {
      botContainer = document.createElement('div');
      botContainer.id = botId;
      document.body.appendChild(botContainer);
    } else {
      botContainer.style.display = 'block';
    }

    // Only add the script if it's not already present
    let script = document.getElementById(scriptId);
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://app.progpt.biz/embed.js';
      script.async = true;
      script.setAttribute('data-width', '500px');
      script.setAttribute('data-height', '500px');
      script.setAttribute('p_id', '52711c82-dc1b-4f89-a694-48a91f84c63c');
      document.body.appendChild(script);
    }

    // remove this if you want container to persist
    return () => {
      // if (botContainer) botContainer.remove();
      // document.body.removeChild(script);

      if (botContainer) {
        botContainer.style.display = 'none';
      }
    };
  }, []);

  return null;
}

export default ProGPTBotLoader;
